/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssistitoAllergiaCreateDTO,
  AssistitoAllergiaDTO,
  AssistitoAllergiaUpdateDTO,
  AssistitoContattoCreateDTO,
  AssistitoContattoDTO,
  AssistitoContattoUpdateDTO,
  AssistitoCreateDTO,
  AssistitoDTO,
  AssistitoIntolleranzaCreateDTO,
  AssistitoIntolleranzaDTO,
  AssistitoIntolleranzaUpdateDTO,
  AssistitoMalattiaCreateDTO,
  AssistitoMalattiaDTO,
  AssistitoMalattiaUpdateDTO,
  AssistitoPatologiaInfettivaCreateDTO,
  AssistitoPatologiaInfettivaDTO,
  AssistitoPatologiaInfettivaUpdateDTO,
  AssistitoStatusDTO,
  AssistitoTerapiaCreateDTO,
  AssistitoTerapiaDTO,
  AssistitoTerapiaUpdateDTO,
  AssistitoTraumaCreateDTO,
  AssistitoTraumaDTO,
  AssistitoTraumaUpdateDTO,
  AssistitoUpdateDTO,
  FisiologicaGeneraleDTO,
  ProblemDetails,
} from '../models/index';
import {
    AssistitoAllergiaCreateDTOFromJSON,
    AssistitoAllergiaCreateDTOToJSON,
    AssistitoAllergiaDTOFromJSON,
    AssistitoAllergiaDTOToJSON,
    AssistitoAllergiaUpdateDTOFromJSON,
    AssistitoAllergiaUpdateDTOToJSON,
    AssistitoContattoCreateDTOFromJSON,
    AssistitoContattoCreateDTOToJSON,
    AssistitoContattoDTOFromJSON,
    AssistitoContattoDTOToJSON,
    AssistitoContattoUpdateDTOFromJSON,
    AssistitoContattoUpdateDTOToJSON,
    AssistitoCreateDTOFromJSON,
    AssistitoCreateDTOToJSON,
    AssistitoDTOFromJSON,
    AssistitoDTOToJSON,
    AssistitoIntolleranzaCreateDTOFromJSON,
    AssistitoIntolleranzaCreateDTOToJSON,
    AssistitoIntolleranzaDTOFromJSON,
    AssistitoIntolleranzaDTOToJSON,
    AssistitoIntolleranzaUpdateDTOFromJSON,
    AssistitoIntolleranzaUpdateDTOToJSON,
    AssistitoMalattiaCreateDTOFromJSON,
    AssistitoMalattiaCreateDTOToJSON,
    AssistitoMalattiaDTOFromJSON,
    AssistitoMalattiaDTOToJSON,
    AssistitoMalattiaUpdateDTOFromJSON,
    AssistitoMalattiaUpdateDTOToJSON,
    AssistitoPatologiaInfettivaCreateDTOFromJSON,
    AssistitoPatologiaInfettivaCreateDTOToJSON,
    AssistitoPatologiaInfettivaDTOFromJSON,
    AssistitoPatologiaInfettivaDTOToJSON,
    AssistitoPatologiaInfettivaUpdateDTOFromJSON,
    AssistitoPatologiaInfettivaUpdateDTOToJSON,
    AssistitoStatusDTOFromJSON,
    AssistitoStatusDTOToJSON,
    AssistitoTerapiaCreateDTOFromJSON,
    AssistitoTerapiaCreateDTOToJSON,
    AssistitoTerapiaDTOFromJSON,
    AssistitoTerapiaDTOToJSON,
    AssistitoTerapiaUpdateDTOFromJSON,
    AssistitoTerapiaUpdateDTOToJSON,
    AssistitoTraumaCreateDTOFromJSON,
    AssistitoTraumaCreateDTOToJSON,
    AssistitoTraumaDTOFromJSON,
    AssistitoTraumaDTOToJSON,
    AssistitoTraumaUpdateDTOFromJSON,
    AssistitoTraumaUpdateDTOToJSON,
    AssistitoUpdateDTOFromJSON,
    AssistitoUpdateDTOToJSON,
    FisiologicaGeneraleDTOFromJSON,
    FisiologicaGeneraleDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface DeleteAssistitoRequest {
    assistitoId: string;
    tenantId: string;
}

export interface DeleteAssistitoAllergiaRequest {
    assistitoId: string;
    allergiaId: string;
    tenantId: string;
}

export interface DeleteAssistitoContattoRequest {
    assistitoId: string;
    contattoId: string;
    tenantId: string;
}

export interface DeleteAssistitoIntolleranzaRequest {
    assistitoId: string;
    intolleranzaId: string;
    tenantId: string;
}

export interface DeleteAssistitoMalattiaRequest {
    assistitoId: string;
    malattiaId: string;
    tenantId: string;
}

export interface DeleteAssistitoPatologiaInfettivaRequest {
    assistitoId: string;
    patologiaInfettivaId: string;
    tenantId: string;
}

export interface DeleteAssistitoTerapiaRequest {
    assistitoId: string;
    terapiaId: string;
    tenantId: string;
}

export interface DeleteAssistitoTraumaRequest {
    assistitoId: string;
    traumaId: string;
    tenantId: string;
}

export interface GetAssistitiRequest {
    tenantId: string;
}

export interface GetAssistitoAllergiaByIdRequest {
    assistitoId: string;
    allergiaId: string;
    tenantId: string;
}

export interface GetAssistitoAllergieRequest {
    assistitoId: string;
    tenantId: string;
}

export interface GetAssistitoByIdRequest {
    assistitoId: string;
    tenantId: string;
}

export interface GetAssistitoContattiRequest {
    assistitoId: string;
    tenantId: string;
}

export interface GetAssistitoContattoByIdRequest {
    assistitoId: string;
    contattoId: string;
    tenantId: string;
}

export interface GetAssistitoIntolleranzaByIdRequest {
    assistitoId: string;
    intolleranzaId: string;
    tenantId: string;
}

export interface GetAssistitoIntolleranzeRequest {
    assistitoId: string;
    tenantId: string;
}

export interface GetAssistitoMalattiaByIdRequest {
    assistitoId: string;
    malattiaId: string;
    tenantId: string;
}

export interface GetAssistitoMalattieRequest {
    assistitoId: string;
    tenantId: string;
}

export interface GetAssistitoPatologiaInfettivaByIdRequest {
    assistitoId: string;
    patologiaInfettivaId: string;
    tenantId: string;
}

export interface GetAssistitoPatologieInfettiveRequest {
    assistitoId: string;
    tenantId: string;
}

export interface GetAssistitoStatusByIdRequest {
    assistitoId: string;
    tenantId: string;
}

export interface GetAssistitoTerapiaByIdRequest {
    assistitoId: string;
    terapiaId: string;
    tenantId: string;
}

export interface GetAssistitoTerapieRequest {
    assistitoId: string;
    tenantId: string;
}

export interface GetAssistitoTraumaByIdRequest {
    assistitoId: string;
    traumaId: string;
    tenantId: string;
}

export interface GetAssistitoTraumiRequest {
    assistitoId: string;
    tenantId: string;
}

export interface GetFisiologicaGeneraleRequest {
    assistitoId: string;
    tenantId: string;
}

export interface InsertAssistitoRequest {
    tenantId: string;
    assistitoCreateDTO?: AssistitoCreateDTO;
}

export interface InsertAssistitoAllergiaRequest {
    assistitoId: string;
    tenantId: string;
    assistitoAllergiaCreateDTO?: AssistitoAllergiaCreateDTO;
}

export interface InsertAssistitoContattoRequest {
    assistitoId: string;
    tenantId: string;
    assistitoContattoCreateDTO?: AssistitoContattoCreateDTO;
}

export interface InsertAssistitoIntolleranzaRequest {
    assistitoId: string;
    tenantId: string;
    assistitoIntolleranzaCreateDTO?: AssistitoIntolleranzaCreateDTO;
}

export interface InsertAssistitoMalattiaRequest {
    assistitoId: string;
    tenantId: string;
    assistitoMalattiaCreateDTO?: AssistitoMalattiaCreateDTO;
}

export interface InsertAssistitoPatologiaInfettivaRequest {
    assistitoId: string;
    tenantId: string;
    assistitoPatologiaInfettivaCreateDTO?: AssistitoPatologiaInfettivaCreateDTO;
}

export interface InsertAssistitoTerapiaRequest {
    assistitoId: string;
    tenantId: string;
    assistitoTerapiaCreateDTO?: AssistitoTerapiaCreateDTO;
}

export interface InsertAssistitoTraumaRequest {
    assistitoId: string;
    tenantId: string;
    assistitoTraumaCreateDTO?: AssistitoTraumaCreateDTO;
}

export interface UpdateAssistitoRequest {
    assistitoId: string;
    tenantId: string;
    assistitoUpdateDTO?: AssistitoUpdateDTO;
}

export interface UpdateAssistitoAllergiaRequest {
    assistitoId: string;
    allergiaId: string;
    tenantId: string;
    assistitoAllergiaUpdateDTO?: AssistitoAllergiaUpdateDTO;
}

export interface UpdateAssistitoContattoRequest {
    assistitoId: string;
    contattoId: string;
    tenantId: string;
    assistitoContattoUpdateDTO?: AssistitoContattoUpdateDTO;
}

export interface UpdateAssistitoIntolleranzaRequest {
    assistitoId: string;
    intolleranzaId: string;
    tenantId: string;
    assistitoIntolleranzaUpdateDTO?: AssistitoIntolleranzaUpdateDTO;
}

export interface UpdateAssistitoMalattiaRequest {
    assistitoId: string;
    malattiaId: string;
    tenantId: string;
    assistitoMalattiaUpdateDTO?: AssistitoMalattiaUpdateDTO;
}

export interface UpdateAssistitoPatologiaInfettivaRequest {
    assistitoId: string;
    patologiaInfettivaId: string;
    tenantId: string;
    assistitoPatologiaInfettivaUpdateDTO?: AssistitoPatologiaInfettivaUpdateDTO;
}

export interface UpdateAssistitoTerapiaRequest {
    assistitoId: string;
    terapiaId: string;
    tenantId: string;
    assistitoTerapiaUpdateDTO?: AssistitoTerapiaUpdateDTO;
}

export interface UpdateAssistitoTraumaRequest {
    assistitoId: string;
    traumaId: string;
    tenantId: string;
    assistitoTraumaUpdateDTO?: AssistitoTraumaUpdateDTO;
}

export interface UpdateFisiologicaGeneraleRequest {
    assistitoId: string;
    tenantId: string;
    fisiologicaGeneraleDTO?: FisiologicaGeneraleDTO;
}

/**
 * 
 */
export class AssistitiApi extends runtime.BaseAPI {

    /**
     */
    async deleteAssistitoRaw(requestParameters: DeleteAssistitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling deleteAssistito().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteAssistito().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssistito(requestParameters: DeleteAssistitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssistitoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssistitoAllergiaRaw(requestParameters: DeleteAssistitoAllergiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling deleteAssistitoAllergia().'
            );
        }

        if (requestParameters['allergiaId'] == null) {
            throw new runtime.RequiredError(
                'allergiaId',
                'Required parameter "allergiaId" was null or undefined when calling deleteAssistitoAllergia().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteAssistitoAllergia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Allergie/{allergiaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"allergiaId"}}`, encodeURIComponent(String(requestParameters['allergiaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssistitoAllergia(requestParameters: DeleteAssistitoAllergiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssistitoAllergiaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssistitoContattoRaw(requestParameters: DeleteAssistitoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling deleteAssistitoContatto().'
            );
        }

        if (requestParameters['contattoId'] == null) {
            throw new runtime.RequiredError(
                'contattoId',
                'Required parameter "contattoId" was null or undefined when calling deleteAssistitoContatto().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteAssistitoContatto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Contatti/{contattoId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"contattoId"}}`, encodeURIComponent(String(requestParameters['contattoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssistitoContatto(requestParameters: DeleteAssistitoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssistitoContattoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssistitoIntolleranzaRaw(requestParameters: DeleteAssistitoIntolleranzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling deleteAssistitoIntolleranza().'
            );
        }

        if (requestParameters['intolleranzaId'] == null) {
            throw new runtime.RequiredError(
                'intolleranzaId',
                'Required parameter "intolleranzaId" was null or undefined when calling deleteAssistitoIntolleranza().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteAssistitoIntolleranza().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Intolleranze/{intolleranzaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"intolleranzaId"}}`, encodeURIComponent(String(requestParameters['intolleranzaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssistitoIntolleranza(requestParameters: DeleteAssistitoIntolleranzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssistitoIntolleranzaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssistitoMalattiaRaw(requestParameters: DeleteAssistitoMalattiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling deleteAssistitoMalattia().'
            );
        }

        if (requestParameters['malattiaId'] == null) {
            throw new runtime.RequiredError(
                'malattiaId',
                'Required parameter "malattiaId" was null or undefined when calling deleteAssistitoMalattia().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteAssistitoMalattia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Malattie/{malattiaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"malattiaId"}}`, encodeURIComponent(String(requestParameters['malattiaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssistitoMalattia(requestParameters: DeleteAssistitoMalattiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssistitoMalattiaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssistitoPatologiaInfettivaRaw(requestParameters: DeleteAssistitoPatologiaInfettivaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling deleteAssistitoPatologiaInfettiva().'
            );
        }

        if (requestParameters['patologiaInfettivaId'] == null) {
            throw new runtime.RequiredError(
                'patologiaInfettivaId',
                'Required parameter "patologiaInfettivaId" was null or undefined when calling deleteAssistitoPatologiaInfettiva().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteAssistitoPatologiaInfettiva().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/PatologieInfettive/{patologiaInfettivaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"patologiaInfettivaId"}}`, encodeURIComponent(String(requestParameters['patologiaInfettivaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssistitoPatologiaInfettiva(requestParameters: DeleteAssistitoPatologiaInfettivaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssistitoPatologiaInfettivaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssistitoTerapiaRaw(requestParameters: DeleteAssistitoTerapiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling deleteAssistitoTerapia().'
            );
        }

        if (requestParameters['terapiaId'] == null) {
            throw new runtime.RequiredError(
                'terapiaId',
                'Required parameter "terapiaId" was null or undefined when calling deleteAssistitoTerapia().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteAssistitoTerapia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Terapie/{terapiaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"terapiaId"}}`, encodeURIComponent(String(requestParameters['terapiaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssistitoTerapia(requestParameters: DeleteAssistitoTerapiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssistitoTerapiaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAssistitoTraumaRaw(requestParameters: DeleteAssistitoTraumaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling deleteAssistitoTrauma().'
            );
        }

        if (requestParameters['traumaId'] == null) {
            throw new runtime.RequiredError(
                'traumaId',
                'Required parameter "traumaId" was null or undefined when calling deleteAssistitoTrauma().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteAssistitoTrauma().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Traumi/{traumaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"traumaId"}}`, encodeURIComponent(String(requestParameters['traumaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAssistitoTrauma(requestParameters: DeleteAssistitoTraumaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssistitoTraumaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAssistitiRaw(requestParameters: GetAssistitiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssistitoDTO>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistiti().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssistitoDTOFromJSON));
    }

    /**
     */
    async getAssistiti(requestParameters: GetAssistitiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssistitoDTO>> {
        const response = await this.getAssistitiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoAllergiaByIdRaw(requestParameters: GetAssistitoAllergiaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoAllergiaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoAllergiaById().'
            );
        }

        if (requestParameters['allergiaId'] == null) {
            throw new runtime.RequiredError(
                'allergiaId',
                'Required parameter "allergiaId" was null or undefined when calling getAssistitoAllergiaById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoAllergiaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Allergie/{allergiaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"allergiaId"}}`, encodeURIComponent(String(requestParameters['allergiaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoAllergiaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAssistitoAllergiaById(requestParameters: GetAssistitoAllergiaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoAllergiaDTO> {
        const response = await this.getAssistitoAllergiaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoAllergieRaw(requestParameters: GetAssistitoAllergieRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssistitoAllergiaDTO>>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoAllergie().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoAllergie().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Allergie`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssistitoAllergiaDTOFromJSON));
    }

    /**
     */
    async getAssistitoAllergie(requestParameters: GetAssistitoAllergieRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssistitoAllergiaDTO>> {
        const response = await this.getAssistitoAllergieRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoByIdRaw(requestParameters: GetAssistitoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAssistitoById(requestParameters: GetAssistitoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoDTO> {
        const response = await this.getAssistitoByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoContattiRaw(requestParameters: GetAssistitoContattiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssistitoContattoDTO>>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoContatti().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoContatti().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Contatti`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssistitoContattoDTOFromJSON));
    }

    /**
     */
    async getAssistitoContatti(requestParameters: GetAssistitoContattiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssistitoContattoDTO>> {
        const response = await this.getAssistitoContattiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoContattoByIdRaw(requestParameters: GetAssistitoContattoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoContattoDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoContattoById().'
            );
        }

        if (requestParameters['contattoId'] == null) {
            throw new runtime.RequiredError(
                'contattoId',
                'Required parameter "contattoId" was null or undefined when calling getAssistitoContattoById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoContattoById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Contatti/{contattoId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"contattoId"}}`, encodeURIComponent(String(requestParameters['contattoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoContattoDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAssistitoContattoById(requestParameters: GetAssistitoContattoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoContattoDTO> {
        const response = await this.getAssistitoContattoByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoIntolleranzaByIdRaw(requestParameters: GetAssistitoIntolleranzaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoIntolleranzaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoIntolleranzaById().'
            );
        }

        if (requestParameters['intolleranzaId'] == null) {
            throw new runtime.RequiredError(
                'intolleranzaId',
                'Required parameter "intolleranzaId" was null or undefined when calling getAssistitoIntolleranzaById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoIntolleranzaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Intolleranze/{intolleranzaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"intolleranzaId"}}`, encodeURIComponent(String(requestParameters['intolleranzaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoIntolleranzaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAssistitoIntolleranzaById(requestParameters: GetAssistitoIntolleranzaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoIntolleranzaDTO> {
        const response = await this.getAssistitoIntolleranzaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoIntolleranzeRaw(requestParameters: GetAssistitoIntolleranzeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssistitoIntolleranzaDTO>>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoIntolleranze().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoIntolleranze().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Intolleranze`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssistitoIntolleranzaDTOFromJSON));
    }

    /**
     */
    async getAssistitoIntolleranze(requestParameters: GetAssistitoIntolleranzeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssistitoIntolleranzaDTO>> {
        const response = await this.getAssistitoIntolleranzeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoMalattiaByIdRaw(requestParameters: GetAssistitoMalattiaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoMalattiaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoMalattiaById().'
            );
        }

        if (requestParameters['malattiaId'] == null) {
            throw new runtime.RequiredError(
                'malattiaId',
                'Required parameter "malattiaId" was null or undefined when calling getAssistitoMalattiaById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoMalattiaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Malattie/{malattiaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"malattiaId"}}`, encodeURIComponent(String(requestParameters['malattiaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoMalattiaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAssistitoMalattiaById(requestParameters: GetAssistitoMalattiaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoMalattiaDTO> {
        const response = await this.getAssistitoMalattiaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoMalattieRaw(requestParameters: GetAssistitoMalattieRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssistitoMalattiaDTO>>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoMalattie().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoMalattie().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Malattie`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssistitoMalattiaDTOFromJSON));
    }

    /**
     */
    async getAssistitoMalattie(requestParameters: GetAssistitoMalattieRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssistitoMalattiaDTO>> {
        const response = await this.getAssistitoMalattieRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoPatologiaInfettivaByIdRaw(requestParameters: GetAssistitoPatologiaInfettivaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoPatologiaInfettivaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoPatologiaInfettivaById().'
            );
        }

        if (requestParameters['patologiaInfettivaId'] == null) {
            throw new runtime.RequiredError(
                'patologiaInfettivaId',
                'Required parameter "patologiaInfettivaId" was null or undefined when calling getAssistitoPatologiaInfettivaById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoPatologiaInfettivaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/PatologieInfettive/{patologiaInfettivaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"patologiaInfettivaId"}}`, encodeURIComponent(String(requestParameters['patologiaInfettivaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoPatologiaInfettivaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAssistitoPatologiaInfettivaById(requestParameters: GetAssistitoPatologiaInfettivaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoPatologiaInfettivaDTO> {
        const response = await this.getAssistitoPatologiaInfettivaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoPatologieInfettiveRaw(requestParameters: GetAssistitoPatologieInfettiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssistitoPatologiaInfettivaDTO>>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoPatologieInfettive().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoPatologieInfettive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/PatologieInfettive`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssistitoPatologiaInfettivaDTOFromJSON));
    }

    /**
     */
    async getAssistitoPatologieInfettive(requestParameters: GetAssistitoPatologieInfettiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssistitoPatologiaInfettivaDTO>> {
        const response = await this.getAssistitoPatologieInfettiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoStatusByIdRaw(requestParameters: GetAssistitoStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoStatusDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoStatusById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoStatusById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/status`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoStatusDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAssistitoStatusById(requestParameters: GetAssistitoStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoStatusDTO> {
        const response = await this.getAssistitoStatusByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoTerapiaByIdRaw(requestParameters: GetAssistitoTerapiaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoTerapiaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoTerapiaById().'
            );
        }

        if (requestParameters['terapiaId'] == null) {
            throw new runtime.RequiredError(
                'terapiaId',
                'Required parameter "terapiaId" was null or undefined when calling getAssistitoTerapiaById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoTerapiaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Terapie/{terapiaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"terapiaId"}}`, encodeURIComponent(String(requestParameters['terapiaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoTerapiaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAssistitoTerapiaById(requestParameters: GetAssistitoTerapiaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoTerapiaDTO> {
        const response = await this.getAssistitoTerapiaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoTerapieRaw(requestParameters: GetAssistitoTerapieRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssistitoTerapiaDTO>>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoTerapie().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoTerapie().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Terapie`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssistitoTerapiaDTOFromJSON));
    }

    /**
     */
    async getAssistitoTerapie(requestParameters: GetAssistitoTerapieRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssistitoTerapiaDTO>> {
        const response = await this.getAssistitoTerapieRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoTraumaByIdRaw(requestParameters: GetAssistitoTraumaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoTraumaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoTraumaById().'
            );
        }

        if (requestParameters['traumaId'] == null) {
            throw new runtime.RequiredError(
                'traumaId',
                'Required parameter "traumaId" was null or undefined when calling getAssistitoTraumaById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoTraumaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Traumi/{traumaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"traumaId"}}`, encodeURIComponent(String(requestParameters['traumaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoTraumaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAssistitoTraumaById(requestParameters: GetAssistitoTraumaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoTraumaDTO> {
        const response = await this.getAssistitoTraumaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssistitoTraumiRaw(requestParameters: GetAssistitoTraumiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssistitoTraumaDTO>>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getAssistitoTraumi().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getAssistitoTraumi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Traumi`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssistitoTraumaDTOFromJSON));
    }

    /**
     */
    async getAssistitoTraumi(requestParameters: GetAssistitoTraumiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssistitoTraumaDTO>> {
        const response = await this.getAssistitoTraumiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFisiologicaGeneraleRaw(requestParameters: GetFisiologicaGeneraleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FisiologicaGeneraleDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling getFisiologicaGenerale().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getFisiologicaGenerale().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/FisiologicaGenerale`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FisiologicaGeneraleDTOFromJSON(jsonValue));
    }

    /**
     */
    async getFisiologicaGenerale(requestParameters: GetFisiologicaGeneraleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FisiologicaGeneraleDTO> {
        const response = await this.getFisiologicaGeneraleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertAssistitoRaw(requestParameters: InsertAssistitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertAssistito().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoCreateDTOToJSON(requestParameters['assistitoCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertAssistito(requestParameters: InsertAssistitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoDTO> {
        const response = await this.insertAssistitoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertAssistitoAllergiaRaw(requestParameters: InsertAssistitoAllergiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoAllergiaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling insertAssistitoAllergia().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertAssistitoAllergia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Allergie`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoAllergiaCreateDTOToJSON(requestParameters['assistitoAllergiaCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoAllergiaDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertAssistitoAllergia(requestParameters: InsertAssistitoAllergiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoAllergiaDTO> {
        const response = await this.insertAssistitoAllergiaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertAssistitoContattoRaw(requestParameters: InsertAssistitoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoContattoDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling insertAssistitoContatto().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertAssistitoContatto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Contatti`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoContattoCreateDTOToJSON(requestParameters['assistitoContattoCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoContattoDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertAssistitoContatto(requestParameters: InsertAssistitoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoContattoDTO> {
        const response = await this.insertAssistitoContattoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertAssistitoIntolleranzaRaw(requestParameters: InsertAssistitoIntolleranzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoIntolleranzaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling insertAssistitoIntolleranza().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertAssistitoIntolleranza().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Intolleranze`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoIntolleranzaCreateDTOToJSON(requestParameters['assistitoIntolleranzaCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoIntolleranzaDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertAssistitoIntolleranza(requestParameters: InsertAssistitoIntolleranzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoIntolleranzaDTO> {
        const response = await this.insertAssistitoIntolleranzaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertAssistitoMalattiaRaw(requestParameters: InsertAssistitoMalattiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoMalattiaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling insertAssistitoMalattia().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertAssistitoMalattia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Malattie`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoMalattiaCreateDTOToJSON(requestParameters['assistitoMalattiaCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoMalattiaDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertAssistitoMalattia(requestParameters: InsertAssistitoMalattiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoMalattiaDTO> {
        const response = await this.insertAssistitoMalattiaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertAssistitoPatologiaInfettivaRaw(requestParameters: InsertAssistitoPatologiaInfettivaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoPatologiaInfettivaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling insertAssistitoPatologiaInfettiva().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertAssistitoPatologiaInfettiva().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/PatologieInfettive`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoPatologiaInfettivaCreateDTOToJSON(requestParameters['assistitoPatologiaInfettivaCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoPatologiaInfettivaDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertAssistitoPatologiaInfettiva(requestParameters: InsertAssistitoPatologiaInfettivaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoPatologiaInfettivaDTO> {
        const response = await this.insertAssistitoPatologiaInfettivaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertAssistitoTerapiaRaw(requestParameters: InsertAssistitoTerapiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoTerapiaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling insertAssistitoTerapia().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertAssistitoTerapia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Terapie`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoTerapiaCreateDTOToJSON(requestParameters['assistitoTerapiaCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoTerapiaDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertAssistitoTerapia(requestParameters: InsertAssistitoTerapiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoTerapiaDTO> {
        const response = await this.insertAssistitoTerapiaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertAssistitoTraumaRaw(requestParameters: InsertAssistitoTraumaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistitoTraumaDTO>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling insertAssistitoTrauma().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertAssistitoTrauma().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Traumi`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoTraumaCreateDTOToJSON(requestParameters['assistitoTraumaCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistitoTraumaDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertAssistitoTrauma(requestParameters: InsertAssistitoTraumaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistitoTraumaDTO> {
        const response = await this.insertAssistitoTraumaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAssistitoRaw(requestParameters: UpdateAssistitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling updateAssistito().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateAssistito().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoUpdateDTOToJSON(requestParameters['assistitoUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAssistito(requestParameters: UpdateAssistitoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAssistitoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateAssistitoAllergiaRaw(requestParameters: UpdateAssistitoAllergiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling updateAssistitoAllergia().'
            );
        }

        if (requestParameters['allergiaId'] == null) {
            throw new runtime.RequiredError(
                'allergiaId',
                'Required parameter "allergiaId" was null or undefined when calling updateAssistitoAllergia().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateAssistitoAllergia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Allergie/{allergiaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"allergiaId"}}`, encodeURIComponent(String(requestParameters['allergiaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoAllergiaUpdateDTOToJSON(requestParameters['assistitoAllergiaUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAssistitoAllergia(requestParameters: UpdateAssistitoAllergiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAssistitoAllergiaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateAssistitoContattoRaw(requestParameters: UpdateAssistitoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling updateAssistitoContatto().'
            );
        }

        if (requestParameters['contattoId'] == null) {
            throw new runtime.RequiredError(
                'contattoId',
                'Required parameter "contattoId" was null or undefined when calling updateAssistitoContatto().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateAssistitoContatto().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Contatti/{contattoId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"contattoId"}}`, encodeURIComponent(String(requestParameters['contattoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoContattoUpdateDTOToJSON(requestParameters['assistitoContattoUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAssistitoContatto(requestParameters: UpdateAssistitoContattoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAssistitoContattoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateAssistitoIntolleranzaRaw(requestParameters: UpdateAssistitoIntolleranzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling updateAssistitoIntolleranza().'
            );
        }

        if (requestParameters['intolleranzaId'] == null) {
            throw new runtime.RequiredError(
                'intolleranzaId',
                'Required parameter "intolleranzaId" was null or undefined when calling updateAssistitoIntolleranza().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateAssistitoIntolleranza().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Intolleranze/{intolleranzaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"intolleranzaId"}}`, encodeURIComponent(String(requestParameters['intolleranzaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoIntolleranzaUpdateDTOToJSON(requestParameters['assistitoIntolleranzaUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAssistitoIntolleranza(requestParameters: UpdateAssistitoIntolleranzaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAssistitoIntolleranzaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateAssistitoMalattiaRaw(requestParameters: UpdateAssistitoMalattiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling updateAssistitoMalattia().'
            );
        }

        if (requestParameters['malattiaId'] == null) {
            throw new runtime.RequiredError(
                'malattiaId',
                'Required parameter "malattiaId" was null or undefined when calling updateAssistitoMalattia().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateAssistitoMalattia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Malattie/{malattiaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"malattiaId"}}`, encodeURIComponent(String(requestParameters['malattiaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoMalattiaUpdateDTOToJSON(requestParameters['assistitoMalattiaUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAssistitoMalattia(requestParameters: UpdateAssistitoMalattiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAssistitoMalattiaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateAssistitoPatologiaInfettivaRaw(requestParameters: UpdateAssistitoPatologiaInfettivaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling updateAssistitoPatologiaInfettiva().'
            );
        }

        if (requestParameters['patologiaInfettivaId'] == null) {
            throw new runtime.RequiredError(
                'patologiaInfettivaId',
                'Required parameter "patologiaInfettivaId" was null or undefined when calling updateAssistitoPatologiaInfettiva().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateAssistitoPatologiaInfettiva().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/PatologieInfettive/{patologiaInfettivaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"patologiaInfettivaId"}}`, encodeURIComponent(String(requestParameters['patologiaInfettivaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoPatologiaInfettivaUpdateDTOToJSON(requestParameters['assistitoPatologiaInfettivaUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAssistitoPatologiaInfettiva(requestParameters: UpdateAssistitoPatologiaInfettivaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAssistitoPatologiaInfettivaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateAssistitoTerapiaRaw(requestParameters: UpdateAssistitoTerapiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling updateAssistitoTerapia().'
            );
        }

        if (requestParameters['terapiaId'] == null) {
            throw new runtime.RequiredError(
                'terapiaId',
                'Required parameter "terapiaId" was null or undefined when calling updateAssistitoTerapia().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateAssistitoTerapia().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Terapie/{terapiaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"terapiaId"}}`, encodeURIComponent(String(requestParameters['terapiaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoTerapiaUpdateDTOToJSON(requestParameters['assistitoTerapiaUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAssistitoTerapia(requestParameters: UpdateAssistitoTerapiaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAssistitoTerapiaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateAssistitoTraumaRaw(requestParameters: UpdateAssistitoTraumaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling updateAssistitoTrauma().'
            );
        }

        if (requestParameters['traumaId'] == null) {
            throw new runtime.RequiredError(
                'traumaId',
                'Required parameter "traumaId" was null or undefined when calling updateAssistitoTrauma().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateAssistitoTrauma().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/Traumi/{traumaId}`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"traumaId"}}`, encodeURIComponent(String(requestParameters['traumaId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssistitoTraumaUpdateDTOToJSON(requestParameters['assistitoTraumaUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAssistitoTrauma(requestParameters: UpdateAssistitoTraumaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAssistitoTraumaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateFisiologicaGeneraleRaw(requestParameters: UpdateFisiologicaGeneraleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assistitoId'] == null) {
            throw new runtime.RequiredError(
                'assistitoId',
                'Required parameter "assistitoId" was null or undefined when calling updateFisiologicaGenerale().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateFisiologicaGenerale().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Assistiti/{assistitoId}/FisiologicaGenerale`.replace(`{${"assistitoId"}}`, encodeURIComponent(String(requestParameters['assistitoId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FisiologicaGeneraleDTOToJSON(requestParameters['fisiologicaGeneraleDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateFisiologicaGenerale(requestParameters: UpdateFisiologicaGeneraleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFisiologicaGeneraleRaw(requestParameters, initOverrides);
    }

}
